import React,{useState,Fragment, useEffect} from 'react';
import MetaEditHandler from './metaEditHandler';
import {Table} from 'react-bootstrap';
import { GetMetaDetails } from '../../../entities/action/action';

const MetaDetails = (props)=>{
    const [data,updateData] = useState({});
    useEffect(()=>{
        (async()=>{
            const response = await GetMetaDetails();
            if(response?.success&&response?.meta!==null){
                updateData(response?.meta);
            }
        })()
    },[])
    return(
        <Fragment>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Meta Title</th>
                        <th>Meta Description</th>
                        <th>Meta Keyword</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                {
                    Object.keys(data).length>0?
                    <tr>
                        <td>1</td>
                        <td>{data.metaTitle}</td>
                        <td>{data.description}</td>
                        <td>{data.keyword}</td>
                        <td>
                            <MetaEditHandler data={data}/>
                        </td>
                    </tr>:null     
                } 
               
                </tbody>
            </Table>
        </Fragment>
    )
}
export default MetaDetails